import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { AppBar, Box, Tab, Tabs } from '@material-ui/core';

import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';

import ParamForm from './ParamForm';
import SubgroupSection from './SubgroupSection';

const useStyles = makeStyles(theme => ({
  sectionOutline: {
    width: '97%',
    border: '1px solid #aaffaa',
    background: '#ededed',
    padding: '10px 20px',
    margin: '0 auto',
    marginTop: '10px',
  },
  subgroupTab: {
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

export default function GroupSection({ moduleName, group, updateParam }) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = index => {
    setValue(index);
  };
  return (
    <Box sx={{ bgcolor: 'background.paper', width: '100%' }}>
      {group.subgroups.length > 0 ? (
        <AppBar position="static">
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="secondary"
            textColor="inherit"
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className={classes.subgroupTab}
          >
            {group.subgroups.map((subgroup, index, array) => {
              return <Tab label={subgroup.subgroup} {...a11yProps(index)} />;
            })}
            <Tab label="" {...a11yProps(group.subgroups.length)} />;
          </Tabs>
        </AppBar>
      ) : null}
      <SwipeableViews
        axis={'x-reverse'}
        index={value}
        onChangeIndex={handleChangeIndex}
      >
        {group.subgroups.map((subgroup, index, array) => {
          return (
            <TabPanel value={value} index={index}>
              <SubgroupSection
                key={index}
                moduleName={moduleName}
                groupName={group.group}
                subgroup={subgroup}
                updateParam={updateParam}
              />
            </TabPanel>
          );
        })}
        <TabPanel value={value} index={group.subgroups.length}>
          {group.params.map((param, index, array) => {
            return (
              <ParamForm key={index} item={param} updateParam={updateParam} />
            );
          })}
        </TabPanel>
      </SwipeableViews>
    </Box>
  );
}
